import {
  CorruptedGcpType,
  GcpRequestInstruction,
  SuggestedGcpType,
} from "../../apiFacades/bapi/gcpRequests";
import config from "../../config";

export const getCorruptedMarkerDescription = (type: string) => {
  const isRu = config.language === "ru";

  const typeToNameRecord: Record<string, string> = {
    [CorruptedGcpType.REPLACE_BROKEN]: isRu ? "Поврежден" : "Damaged",
    [CorruptedGcpType.REPLACE_SMALL]: isRu ? "Нераспознаваем" : "Undetectable",
    [CorruptedGcpType.CLEANUP_STUFF]: isRu ? "Перекрыт" : "Obstructed",
    [CorruptedGcpType.CLEANUP_DIRT]: isRu
      ? "Трава/грязь/снег"
      : "Covered (dirt/grass/snow)",
    [CorruptedGcpType.CLEANUP_REPAINT]: isRu ? "Тусклый" : "Faded",
    [CorruptedGcpType.FIX_COORDINATES]: isRu
      ? "Неверные координаты"
      : "Fix Coordinates",
    [CorruptedGcpType.CHECK_CONDITION]: isRu
      ? "Проверить состояние"
      : "Check Condition",
    [CorruptedGcpType.OTHER]: isRu ? "Другие проблемы" : "Other Problem",
  };
  return typeToNameRecord[type] || "";
};

export const getSuggestedMarkerDescription = (type?: SuggestedGcpType) => {
  const isRu = config.language === "ru";
  switch (type) {
    case SuggestedGcpType.ADD_NEW:
      return isRu ? "Установить новый" : "Add New";
    case SuggestedGcpType.SEND_COORDINATES:
      return isRu ? "Отправить координаты" : "Send Coordinates";
    default:
      return "";
  }
};

export const getExistingGcpDescription = (
  comment: string,
  isApproximate: boolean,
  highPriority: boolean,
) => {
  const isRu = config.language === "ru";
  let description = isRu ? "Существующая точка" : "Existing Control";

  if (highPriority) {
    description += isRu ? " - Проверьте в первую очередь" : " - Check First";
  }

  if (isApproximate) {
    description += isRu ? " - Примерные Координаты" : " - Approximate Location";
  }

  if (comment) {
    description += " - " + comment;
  }
  return description;
};

export const getPlacedMarkerDescription = (
  name: string,
  gisComment: string | null,
): string => {
  // GIS started saving measured Existing Controls as QC, with "measurementGuideComment" being saved as a GIS comment.
  // Eventually these EC will be migrated to a separate control type.
  const isEc = /^(EC_)|(IDP_)/i.test(name);

  return isEc ? gisComment ?? "" : "";
};

export const getInstructionText = (
  markerId: string,
  instructionRecord: Record<string, GcpRequestInstruction[]>,
) => {
  const instructions = instructionRecord[markerId] || [];
  let text: string = "";
  for (const instruction of instructions) {
    switch (instruction) {
      case GcpRequestInstruction.REMEASURE:
        text += "Needs Remeasuring";
    }
  }
  return text;
};
